import React from 'react';
import { Box, Text } from '@nimbus-ds/components';
import AppLayout from 'App/components/AppLayout';
import { useTranslationWithPrefix } from 'commons/utils';

function SettlementSkeleton(): JSX.Element {
  const { t } = useTranslationWithPrefix('settlementPeriod');

  return (
    <AppLayout title={t('title')}>
      <Box
        display="flex"
        flexDirection="column"
        gap="4"
        data-testid="settlement-period-skeleton"
      >
        <Text.Skeleton />
      </Box>
    </AppLayout>
  );
}

export default SettlementSkeleton;
